module.exports = __webpack_public_path__ + "static/media/posto-shell-mobile.23739f4e.png";